// Informações da mesa editáveis na tela de lançar (ADICIONAR ITENS): cliente,
// comanda, pessoas e observação. O Voltar grava o que mudou (dono, 25/09/2026)
// — antes só o ENVIAR gravava, e ele exige produto novo no carrinho.

const txt = (v) => (v == null ? "" : String(v).trim());

// Os valores como o ENVIAR grava: comanda em branco mantém a que a mesa tinha
export function infoEditada({ mesa, clienteNome, clienteId, comandaVal, pessoasVal, observacao }) {
  return {
    cliente: clienteNome || "",
    cliente_id: clienteId || null,
    comanda: txt(comandaVal) ? txt(comandaVal) : (txt(mesa?.comanda) ? mesa.comanda : null),
    pessoas: parseInt(pessoasVal, 10) || 0,
    observacao: txt(observacao) || null,
  };
}

export function infoMudou(mesa, info) {
  return txt(mesa?.cliente) !== txt(info.cliente)
    || txt(mesa?.cliente_id) !== txt(info.cliente_id)
    || txt(mesa?.comanda) !== txt(info.comanda)
    || (Number(mesa?.pessoas) || 0) !== info.pessoas
    || txt(mesa?.observacao) !== txt(info.observacao);
}

// Mesma regra do ENVIAR: outra mesa aberta ou aguardando pagamento com a comanda
export function comandaEmUso(mesas, mesaId, comanda) {
  if (!txt(comanda)) return false;
  return (mesas || []).some((m) => (m.status === "aberta" || m.status === "fechamento")
    && m.id !== mesaId && txt(m.comanda) === txt(comanda));
}

// Só mesa com conta aberta guarda informação: mesa livre sem nada enviado
// continua livre (o que foi digitado nela vai junto no primeiro ENVIAR)
export const guardaInfo = (mesa) => mesa?.status === "aberta" || mesa?.status === "fechamento";

// Observação do PEDIDO da mesa, no formato da criação ("Comanda: 12 — sem gelo"):
// é o que o KDS mostra no cartão e o que aparece no pedido (dono, 25/09/2026)
export function observacaoDoPedido(comanda, observacao) {
  return [txt(comanda) ? `Comanda: ${txt(comanda)}` : null, txt(observacao) || null].filter(Boolean).join(" — ");
}

// Mudou algo que entra na observação do pedido?
export const obsDoPedidoMudou = (mesa, info) =>
  txt(mesa?.comanda) !== txt(info.comanda) || txt(mesa?.observacao) !== txt(info.observacao);
